export default "__VITE_ASSET__CIJRJ8AF__"